import NaverPayProductType from 'common/constants/product/naverPayProductType'
import NaverPayChannelType from 'common/constants/product/naverPayChannelType'
import { NaverPayDeliveryType, NaverPayDeliveryFeeType } from 'common/constants/naverPay'

export interface NaverPay {
  productNo?: string
  productName?: string
  merchantNo?: string
  productUnitPrice?: number
  purchaseItems?: PurchaseProduct[]
  merchantImmediateDiscountAmount?: string
  managerImmediateDiscountAmount?: string
  deliveryMethod?: NaverPayDeliveryType
  deliveryFeePayMethod?: NaverPayDeliveryFeeType
  nnbCookie?: string
  checkoutInflowCode?: string
  cpaInflowCode?: string
  womCode?: string
  mobileAccess?: boolean
  deviceClassType?: NaverPayDeviceType
  extraData?: any
  saleChannelType?: NaverPayChannelType
  mcstCultureBenefitYn?: boolean
}

export interface PurchaseProduct {
  itemName?: string
  itemClassType?: NaverPayProductType
  orderQuantity?: number
  unitPrice?: number
  itemNo?: string
  itemContents?: string
}

export enum NaverPayDeviceType {
  PC = 'PC',
  MOBILE = 'MOBILE',
}
